// extracted by mini-css-extract-plugin
export default {"root":"subNav-module--root--icacj","active":"subNav-module--active--XsOuT","linkActive":"subNav-module--linkActive--REqyW"};